const axiosUpdatedEvent = new Event('axiosUpdate');

function dispatchAxiosUpdatedEvent() {
	window.dispatchEvent(axiosUpdatedEvent);
}

export default dispatchAxiosUpdatedEvent;
